/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import Warning from 'assets/images/warning.svg';
import companyId from 'services/company_id';
import { ApplicationState } from 'store';
import { saveInterestLots } from 'store/modules/monitoring_store/actions';
import { MonitoringBiddingTypes, MonitoringState } from 'store/modules/monitoring_store/types';
import { ProfileState } from 'store/modules/profile_store/types';

interface MonitoringLotsModalProps {
  setInterestLotsModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
  interestLotsModalOpened: boolean;
  selectedTradingId: number;
  trading: MonitoringBiddingTypes | undefined;
}

interface AvailableLotsTypes {
  value: number | null;
  label: string;
  color: string | null;
}

const MonitoringLotsModal = (props: MonitoringLotsModalProps) => {
  const { setInterestLotsModalOpened, interestLotsModalOpened, selectedTradingId, trading } = props;

  const { monitoring } = useSelector<ApplicationState, MonitoringState>(
    (state) => state.storage.monitoring,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const [selectedInterestLots, setSelectedInterestLots] = useState<Array<AvailableLotsTypes>>([]);
  const [availableInterestLots, setAvailableInterestLots] = useState<Array<AvailableLotsTypes>>([]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!trading) return;
    if (trading.lots?.length === 0) return;

    setAvailableInterestLots(
      trading?.lots?.map((lot) => {
        return {
          value: lot,
          label: `Lote ${lot}`,
          color:
            trading?.have_new_messages_lots?.filter(
              (haveNewMessageLot) => haveNewMessageLot === lot,
            )?.length > 0
              ? 'red'
              : null,
        };
      }),
    );

    if (!monitoring.interest_lots[`${selectedTradingId}_${companyId(profile)}`]?.length) {
      setSelectedInterestLots(
        trading?.lots?.map((lot) => {
          return {
            value: lot,
            label: `Lote ${lot}`,
            color:
              trading?.have_new_messages_lots?.filter(
                (haveNewMessageLot) => haveNewMessageLot === lot,
              )?.length > 0
                ? 'red'
                : null,
          };
        }),
      );
      return;
    }

    setSelectedInterestLots(
      monitoring?.interest_lots[`${selectedTradingId}_${companyId(profile)}`]?.map(
        (interestLot) => {
          return {
            value: interestLot.lot,
            label: `Lote ${interestLot?.lot}`,
            color:
              trading?.have_new_messages_lots.filter(
                (haveNewMessageLot) => haveNewMessageLot === interestLot?.lot,
              )?.length > 0
                ? 'red'
                : null,
          };
        },
      ),
    );
  }, [monitoring]);

  return (
    <Modal size="lg" show={interestLotsModalOpened}>
      <div className="modal-header dark-bg">
        <h5 className="modal-title text-light" id="staticBackdropLabel">
          Selecionar os lotes de interesse
        </h5>
        <button
          type="button"
          className="close text-light"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => setInterestLotsModalOpened(false)}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        {trading?.source_id === 5204 && (
          <div className="bg-warning p-2 rounded mb-3">
            <div className="d-flex mb-3 align-content-center">
              <h6 className="d-flex align-items-end m-0 font-weight-bold">PORTAL LICITANET</h6>
              <img className="ml-2" src={Warning} width="25px" />
            </div>
            <span>
              Não recomendamos o uso do filtro por lotes no monitoramento de chat pois em alguns
              casos, o Licitanet pode publicar comunicações gerais apenas no lote 1 ou o pregoeiro
              pode enviar comunicações gerais em lotes específicos. Isso pode fazer com que
              mensagens relevantes não apareçam quando o filtro por lote estiver ativo.
            </span>
          </div>
        )}
        <p>Selecione os lotes que quer acompanhar</p>
        <div className="row">
          <div className="col-md-12">
            <Select
              name="selectLots"
              isMulti
              closeMenuOnSelect={false}
              value={selectedInterestLots}
              onChange={(event) => setSelectedInterestLots([...event])}
              options={availableInterestLots}
              placeholder="Selecione os lotes"
              noOptionsMessage={() => 'Vazio'}
            />
          </div>
          <div className="col-md-12 mt-4 text-center">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={() => {
                dispatch(
                  saveInterestLots(
                    trading?.id || 0,
                    selectedInterestLots?.map((interestLot) => interestLot.value),
                    companyId(profile),
                  ),
                );
                setInterestLotsModalOpened(false);
              }}
              data-dismiss="modal"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MonitoringLotsModal;
